
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, lambda_type, unit_type, union_type, option_type, class_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { FormState__getValidation, FormState__setValidationResponse_5219762A, ConsumableId, FormState_get_empty, FormState_$reflection, ClientApiResponse$1_$reflection } from "../../Shared/Shared.js";
import { ConsumableStateChangedDto, ConsumableState_$reflection, ConsumableDetailDto_$reflection } from "../../Shared/Consumable.js";
import { Cmd_ofEffect, Cmd_batch, Cmd_none } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { unwrap, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { toISOString } from "../../Common.js";
import { putStateChanged } from "../../Requests/Consumable.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { singleton as singleton_1, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { singleton, empty, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { DatePicker } from "../../Components/DatePicker.js";
import { TextArea } from "../../Components/TextArea.js";
import { ErrorAlert } from "../../Components/Alert.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Dialog } from "../../Components/Dialog.js";
import { TextButton } from "../../Components/Button.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateState", "SetComment", "SetDate", "StateUpdated", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Consumables.Dialog.StateChangeDialog.Msg", [], Msg, () => [[], [["Item", string_type]], [["Item", option_type(class_type("System.DateTime"))]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

class State extends Record {
    constructor(Consumable, NewState, Comment$, Date$, OnClose, SuccessCallback, FormState) {
        super();
        this.Consumable = Consumable;
        this.NewState = NewState;
        this.Comment = Comment$;
        this.Date = Date$;
        this.OnClose = OnClose;
        this.SuccessCallback = SuccessCallback;
        this.FormState = FormState;
    }
}

function State_$reflection() {
    return record_type("Consumables.Dialog.StateChangeDialog.State", [], State, () => [["Consumable", ConsumableDetailDto_$reflection()], ["NewState", ConsumableState_$reflection()], ["Comment", string_type], ["Date", option_type(class_type("System.DateTime"))], ["OnClose", lambda_type(unit_type, unit_type)], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["FormState", FormState_$reflection()]]);
}

function init(consumable, newState, successCallback, onClose) {
    return [new State(consumable, newState, "", undefined, onClose, successCallback, FormState_get_empty()), Cmd_none()];
}

function update(msg, state) {
    switch (msg.tag) {
        case 1:
            return [new State(state.Consumable, state.NewState, msg.fields[0], state.Date, state.OnClose, state.SuccessCallback, state.FormState), Cmd_none()];
        case 0: {
            const dto = new ConsumableStateChangedDto(state.NewState, state.Comment, map(toISOString, state.Date));
            return [state, putStateChanged(new ConsumableId(parse(state.Consumable.Id)), dto, (Item_1) => (new Msg(3, [Item_1])), (Item_2) => (new Msg(4, [Item_2])))];
        }
        case 3: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new State(state.Consumable, state.NewState, state.Comment, state.Date, state.OnClose, state.SuccessCallback, FormState__setValidationResponse_5219762A(state.FormState, response.fields[0])), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.Consumable, state.NewState, state.Comment, state.Date, state.OnClose, state.SuccessCallback, FormState_get_empty()), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                }), Cmd_successToast("general.saved_successfully")]))];
            }
        }
        case 4:
            return [state, Cmd_none()];
        default:
            return [new State(state.Consumable, state.NewState, state.Comment, msg.fields[0], state.OnClose, state.SuccessCallback, state.FormState), Cmd_none()];
    }
}

function DialogBody(props) {
    let elems;
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-5"])], (elems = toList(delay(() => append((props.NewState.tag === 0) ? (empty()) : singleton(createElement(DatePicker, {
        ComponentState: componentState,
        IsClearable: true,
        Label: t("general.date"),
        OnChange: (arg) => {
            props.Dispatch(new Msg(2, [arg]));
        },
        TestId: "",
        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "date")),
        Value: unwrap(props.Date),
    })), delay(() => append(singleton(createElement(TextArea, {
        ComponentState: componentState,
        Label: t("general.comment"),
        OnChange: (arg_1) => {
            props.Dispatch(new Msg(1, [arg_1]));
        },
        TestId: "tool-state-change-dialog-comment-test-id",
        Value: props.Comment,
    })), delay(() => {
        const matchValue_1 = FormState__getValidation(props.FormState, t, "global");
        if (matchValue_1 == null) {
            return empty();
        }
        else {
            return singleton(createElement(ErrorAlert, {
                Label: matchValue_1,
            }));
        }
    })))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function StateChangeDialog(props) {
    let Title;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.Consumable, props.NewState, props.SuccessCallback, props.OnClose), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    return createElement(Dialog, (Title = ((props.NewState.tag === 1) ? t("tool.retire_tool") : t("tool.activate_tool")), {
        Body: singleton_1(createElement(DialogBody, {
            Comment: state_1.Comment,
            Consumable: props.Consumable,
            Date: unwrap(state_1.Date),
            Dispatch: dispatch,
            FormState: state_1.FormState,
            NewState: props.NewState,
            SuccessCallback: props.SuccessCallback,
        })),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: "enabled",
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-state-change-dialog-test-id",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: "enabled",
            Label: t("general.save"),
            OnClick: () => {
                dispatch(new Msg(0, []));
            },
            TestId: "save-state-change-dialog-test-id",
            Variant: "blueButton",
        })]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

